import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

const inp = "w-full rounded-lg border border-slate-200 px-3.5 py-2.5 text-sm outline-none focus:border-brand-blue";
const Lbl = ({ children }) => <span className="text-sm font-medium text-slate-700 block mb-1.5">{children}</span>;

export default function AdminAccount() {
  const { logout } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (nw.length < 8) { setError("New password must be at least 8 characters."); return; }
    if (nw !== cf) { setError("New passwords do not match."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      setCur(""); setNw(""); setCf("");
      toast.success("Password updated. Please log in again.");
      setTimeout(() => { logout(); }, 1200);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-account-view" className="max-w-lg">
      <h2 className="font-display text-2xl font-bold text-navy">Account Security</h2>
      <p className="text-slate-500 text-sm mt-1">Change your owner login password. Once you change it here, it stays as you set it.</p>

      <form onSubmit={submit} className="mt-8 rounded-xl border border-slate-200 bg-white p-6 space-y-4">
        <div className="flex items-center gap-2 text-navy font-semibold">
          <KeyRound size={18} className="text-brand-blue" /> Change password
        </div>
        <div>
          <Lbl>Current password</Lbl>
          <input type="password" required value={cur} onChange={(e) => setCur(e.target.value)} className={inp} data-testid="change-password-current" autoComplete="current-password" />
        </div>
        <div>
          <Lbl>New password</Lbl>
          <input type="password" required value={nw} onChange={(e) => setNw(e.target.value)} className={inp} data-testid="change-password-new" autoComplete="new-password" placeholder="At least 8 characters" />
        </div>
        <div>
          <Lbl>Confirm new password</Lbl>
          <input type="password" required value={cf} onChange={(e) => setCf(e.target.value)} className={inp} data-testid="change-password-confirm" autoComplete="new-password" />
        </div>
        {error && <p data-testid="change-password-error" className="text-sm text-red-500">{error}</p>}
        <button type="submit" disabled={saving} data-testid="change-password-submit"
          className="inline-flex items-center gap-2 rounded-lg bg-brand-blue px-6 py-3 text-sm font-semibold text-white hover:bg-blue-500 disabled:opacity-60">
          {saving ? <Loader2 size={16} className="animate-spin" /> : <KeyRound size={16} />} Update password
        </button>
      </form>
    </div>
  );
}
